import React from "react";

/**
 * Tiny inline gender marker rendered next to a @handle.
 * Renders nothing if gender is missing (legacy users, bots).
 */
export function GenderBadge({ gender, className = "" }) {
  if (gender !== "male" && gender !== "female") return null;
  const symbol = gender === "male" ? "\u2642" : "\u2640"; // ♂ / ♀
  const color = gender === "male" ? "text-cyan_wire" : "text-hotpink";
  const label = gender === "male" ? "Male" : "Female";
  return (
    <span
      title={label}
      aria-label={label}
      data-testid={`gender-badge-${gender}`}
      className={`inline-block font-mono ${color} ${className}`}
    >
      {symbol}
    </span>
  );
}
